import { lumi } from '@/lib/lumi'
import { notifyFormSubmission } from '@/lib/notifyFormSubmission'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import { usePageMeta } from '@/hooks/usePageMeta'

interface Question {
  id: string
  number: number
  label: string
}

interface Block {
  title: string
  subtitle: string
  intro: string
  accent: string
  accentSoft: string
  questions: Question[]
}

const BLOCKS: Block[] = [
  {
    title: 'Bloco Elemento Terra',
    subtitle: 'TER',
    intro: 'Terra é a sua base. É tudo que diz respeito ao corpo, ao material, ao dinheiro, à segurança e à estabilidade. Sem uma base sólida, nenhum outro elemento consegue florescer. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    accent: '#6B8E4E',
    accentSoft: '#8FAE6F',
    questions: [
      { id: 'q5', number: 5, label: 'O que você quer TER na sua vida? Descreva com detalhes, no financeiro, no corpo, na saúde, na estabilidade e em tudo que representa segurança e conquista para você. (Seja específica. Quanto mais você detalhar, mais profundo será o seu mapa.)' },
      { id: 'q6', number: 6, label: 'O que te impede de decidir mudar sua vida agora? O que, ou quem, te prende no mesmo lugar?' },
      { id: 'q7', number: 7, label: 'Você sente que não merece ter prosperidade, abundância e estabilidade? De onde veio essa crença?' },
      { id: 'q8', number: 8, label: 'Quem na sua vida, pai, mãe, parceiro ou familiar, te passou a ideia de que dinheiro é difícil, escasso ou perigoso?' },
      { id: 'q9', number: 9, label: 'Você tem vergonha de algo do seu passado que ainda carrega hoje? O que é?' },
      { id: 'q10', number: 10, label: 'O que você evita decidir ou assumir na sua vida por medo de errar ou decepcionar alguém?' },
    ],
  },
  {
    title: 'Bloco Elemento Água',
    subtitle: 'SENTIR',
    intro: 'Água é tudo que diz respeito às suas emoções, aos seus relacionamentos, ao merecimento e ao prazer de viver. Quando a Água está bloqueada, a vida perde sabor e as relações perdem profundidade. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    accent: '#3B7BB8',
    accentSoft: '#5FA0D9',
    questions: [
      { id: 'q11', number: 11, label: 'Como você quer se SENTIR na sua vida? Descreva como quer estar emocionalmente, como quer se relacionar, o que quer sentir no amor, nas amizades e em você mesma. (Quanto mais você detalhar, mais profundo será o seu mapa.)' },
      { id: 'q12', number: 12, label: 'Quem você realmente não quer mais na sua vida, mas ainda mantém por obrigação, culpa ou medo?' },
      { id: 'q13', number: 13, label: 'Você acredita que merece receber amor, cuidado e coisas boas? Se não, por quê?' },
      { id: 'q14', number: 14, label: 'Existe alguém com quem você se compara e sente que não é suficiente? Quem é e por quê?' },
      { id: 'q15', number: 15, label: 'Quem te ensinou que demonstrar sentimentos é fraqueza ou que suas emoções não importam?' },
      { id: 'q16', number: 16, label: 'Existe algum relacionamento, afetivo, familiar ou de amizade, que drena sua energia e mesmo assim você mantém? O que te prende nele?' },
    ],
  },
  {
    title: 'Bloco Elemento Fogo',
    subtitle: 'FAZER',
    intro: 'Fogo é tudo que diz respeito à sua ação, ao seu trabalho, ao seu propósito e ao seu poder pessoal. Quando o Fogo está bloqueado, você começa e não termina, procrastina e sente que nunca chega lá. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    accent: '#E07B3C',
    accentSoft: '#F09A5E',
    questions: [
      { id: 'q17', number: 17, label: 'O que você vai FAZER para criar a vida que deseja? Descreva seus projetos, seu trabalho, seu propósito e as ações que quer tomar. (Quanto mais você detalhar, mais profundo será o seu mapa.)' },
      { id: 'q18', number: 18, label: 'O que você fica adiando que sabe que precisa fazer? Por que não faz?' },
      { id: 'q19', number: 19, label: 'Você sente que não é boa o suficiente para ter sucesso? De onde veio essa crença?' },
      { id: 'q20', number: 20, label: 'Existe alguém cuja opinião ou julgamento te paralisa e te impede de agir? Quem é?' },
      { id: 'q21', number: 21, label: 'Quais padrões de autossabotagem você percebe se repetindo na sua vida, no trabalho, nos projetos e nas finanças?' },
      { id: 'q22', number: 22, label: 'O que te faz desanimar e querer parar quando está quase chegando lá?' },
    ],
  },
  {
    title: 'Bloco Elemento Ar',
    subtitle: 'AMAR',
    intro: 'Ar é tudo que diz respeito ao amor, ao perdão, à paz e ao equilíbrio. É o elemento mais elevado e só se abre quando os outros três começam a se mover. Quando o Ar está bloqueado, há raiva, mágoa, dificuldade de perdoar e de receber. Quanto mais você detalhar aqui, mais profundo será o que seu campo revelará.',
    accent: '#B9A3D9',
    accentSoft: '#D4C3EA',
    questions: [
      { id: 'q23', number: 23, label: 'Como você vai AMAR e se relacionar quando tiver a vida que deseja? Descreva como quer amar, ser amada, viver em paz e se conectar com o Divino. (Quanto mais você detalhar, mais profundo será o seu mapa.)' },
      { id: 'q24', number: 24, label: 'Existe alguém que você ainda não perdoou e que carrega como um peso? Quem é e o que aconteceu?' },
      { id: 'q25', number: 25, label: 'Você consegue pedir ajuda quando precisa ou prefere resolver tudo sozinha? O que te impede de receber?' },
      { id: 'q26', number: 26, label: 'Como é a sua relação com seu pai e sua mãe, ou com as figuras que representam o masculino e o feminino na sua vida? Existe mágoa, distância ou algo não resolvido?' },
      { id: 'q27', number: 27, label: 'Existe raiva, ressentimento ou mágoa que você carrega em relação a alguém e que ainda não conseguiu soltar? Quem é essa pessoa?' },
      { id: 'q28', number: 28, label: 'O que, ou quem, te impede de viver em paz e em equilíbrio hoje?' },
    ],
  },
]

const TOTAL_BLOCKS = 4
const ALL_TEXT_IDS = BLOCKS.flatMap(b => b.questions.map(q => q.id))
const PAGE_ACCENT = '#C8923A'
const PAGE_ACCENT_SOFT = '#E0B870'

export default function PageFormularioMapaCura() {
  usePageMeta({
    title: 'Mapa de Cura dos 4 Elementos — Reative os 4 Elementos',
    description: 'Formulário do Mapa de Cura dos 4 Elementos. Responda com verdade e profundidade para revelar o que está guardado no seu campo.',
    ogImage: 'https://static.lumi.new/76/768cd02825460eb1548b4156e8d0d987.svg',
    ogUrl: 'https://jornada.reacendaluz.com.br/formulario/mapa/',
  })

  const [step, setStep] = useState(0)
  const [direction, setDirection] = useState(1)
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [whatsapp, setWhatsapp] = useState('')
  const [idade, setIdade] = useState('')
  const [answers, setAnswers] = useState<Record<string, string>>({})
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  function updateAnswer(id: string, value: string) {
    setAnswers(prev => ({ ...prev, [id]: value }))
    setError('')
  }

  const progressBlock = step === 0 ? 0 : step
  const progressPercent = (progressBlock / TOTAL_BLOCKS) * 100
  const currentAccent = step >= 1 && step <= TOTAL_BLOCKS ? BLOCKS[step - 1].accent : PAGE_ACCENT
  const currentAccentSoft = step >= 1 && step <= TOTAL_BLOCKS ? BLOCKS[step - 1].accentSoft : PAGE_ACCENT_SOFT

  function handleContinue() {
    setError('')

    if (step === 0) {
      const trimEmail = email.trim()
      const trimName = name.trim()
      const trimWhatsapp = whatsapp.trim()
      const trimIdade = idade.trim()
      if (!trimEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimEmail)) {
        setError('Por favor informe um e-mail válido.')
        document.getElementById('field-email')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      if (!trimName) {
        setError('Por favor informe seu nome completo.')
        document.getElementById('field-name')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      if (!trimWhatsapp) {
        setError('Por favor informe seu WhatsApp com DDD.')
        document.getElementById('field-whatsapp')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      if (!trimIdade) {
        setError('Por favor informe sua idade.')
        document.getElementById('field-idade')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }
      advance()
      return
    }

    if (step >= 1 && step <= TOTAL_BLOCKS) {
      const block = BLOCKS[step - 1]
      for (const q of block.questions) {
        if (!(answers[q.id] || '').trim()) {
          setError('Por favor responda todas as perguntas deste bloco antes de continuar.')
          document.getElementById(`field-${q.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
          return
        }
      }
      if (step === TOTAL_BLOCKS) {
        handleSubmit()
      } else {
        advance()
      }
    }
  }

  function advance() {
    setDirection(1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setStep(prev => prev + 1)
  }

  async function handleSubmit() {
    setSubmitting(true)
    try {
      const now = new Date().toISOString()
      const payload: Record<string, unknown> = {
        email: email.trim(),
        name: name.trim(),
        whatsapp: whatsapp.trim(),
        idade: idade.trim(),
        createdAt: now,
        updatedAt: now,
      }
      for (const id of ALL_TEXT_IDS) {
        payload[id] = (answers[id] || '').trim()
      }
      await lumi.entities.formulario_mapa_cura.create(payload)
      notifyFormSubmission({ name: name.trim(), formName: 'Mapa de Cura dos 4 Elementos', submittedAt: now })
      setSubmitted(true)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } catch (err) {
      console.error('Erro ao enviar Mapa de Cura:', err)
      setError('Não foi possível enviar agora. Tente novamente em instantes.')
    } finally {
      setSubmitting(false)
    }
  }

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#0a0f14] flex items-center justify-center px-5 py-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="max-w-xl w-full text-center"
        >
          <p className="text-[10px] tracking-[0.4em] uppercase font-body mb-6" style={{ color: PAGE_ACCENT_SOFT }}>
            Mapa de Cura dos 4 Elementos
          </p>
          <div
            className="w-16 h-16 rounded-full mx-auto mb-8 flex items-center justify-center"
            style={{ background: `${PAGE_ACCENT}18`, border: `1px solid ${PAGE_ACCENT_SOFT}55` }}
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke={PAGE_ACCENT_SOFT}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="font-display type-hero mb-6" style={{ color: 'var(--ink,#e8e0d5)' }}>
            Suas respostas{' '}
            <em className="italic font-light" style={{ color: PAGE_ACCENT_SOFT }}>
              chegaram
            </em>
          </h1>
          <p className="font-body type-body mb-5" style={{ color: 'rgba(232,224,213,0.75)' }}>
            Obrigada por se expressar com verdade e profundidade.
          </p>
          <p className="font-body type-body mb-5" style={{ color: 'rgba(232,224,213,0.7)' }}>
            Lerei tudo com cuidado e presença para criar o seu Mapa de Cura dos 4 Elementos.
          </p>
          <p className="font-body type-body italic" style={{ color: 'rgba(232,224,213,0.55)' }}>
            Com amor e presença, Mônica Maria — Terapeuta Vibracional
          </p>
          <div
            className="h-px w-24 mx-auto mt-12"
            style={{ background: `linear-gradient(90deg, transparent, ${PAGE_ACCENT_SOFT}66, transparent)` }}
          />
          <p className="text-[10px] tracking-[0.3em] uppercase font-body mt-8" style={{ color: 'rgba(232,224,213,0.45)' }}>
            Mônica Maria — @reacendaluz
          </p>
        </motion.div>
      </div>
    )
  }

  const isLastStep = step === TOTAL_BLOCKS

  return (
    <div className="min-h-screen bg-[#0a0f14]">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 py-14 sm:py-20">
        <motion.header
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-10 sm:mb-14"
        >
          <h1 className="font-display type-hero mb-6" style={{ color: 'var(--ink,#e8e0d5)' }}>
            Mapa de Cura dos{' '}
            <span className="numerals">4</span>
            {' '}Elementos
          </h1>
          <p className="font-body type-body mb-5" style={{ color: 'rgba(232,224,213,0.75)', lineHeight: 1.8 }}>
            Este mapa é um convite para você se expressar com verdade e profundidade. Não existe resposta certa ou errada, existe o que é real para você agora. Leia cada pergunta com calma e escreva o que vier primeiro, sem filtro e sem julgamento. Quanto mais você detalhar, mais profundo será o seu mapa e mais ele revelará dores que estão guardadas dentro de você.
          </p>
          <p className="font-body type-body italic" style={{ color: 'rgba(232,224,213,0.55)' }}>
            Mônica Maria — Terapeuta Vibracional — @reacendaluz
          </p>
          <div
            className="h-px w-24 mx-auto mt-10"
            style={{ background: `linear-gradient(90deg, transparent, ${PAGE_ACCENT_SOFT}66, transparent)` }}
          />
        </motion.header>

        {step > 0 ? (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-10"
          >
            <div className="flex items-center justify-between mb-3">
              <p className="text-[11px] tracking-[0.3em] uppercase font-body" style={{ color: currentAccentSoft }}>
                Bloco{' '}
                <span className="numerals">{progressBlock}</span>
                {' '}de{' '}
                <span className="numerals">{TOTAL_BLOCKS}</span>
              </p>
              <p className="text-[11px] font-body numerals" style={{ color: 'rgba(232,224,213,0.4)' }}>
                {Math.round(progressPercent)}%
              </p>
            </div>
            <div
              className="w-full h-[2px] rounded-full overflow-hidden"
              style={{ background: 'rgba(255,255,255,0.07)' }}
            >
              <motion.div
                className="h-full rounded-full"
                style={{ background: `linear-gradient(90deg, ${currentAccent}, ${currentAccentSoft})` }}
                initial={{ width: `${((progressBlock - 1) / TOTAL_BLOCKS) * 100}%` }}
                animate={{ width: `${progressPercent}%` }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
              />
            </div>
            <div className="flex justify-between mt-2">
              {Array.from({ length: TOTAL_BLOCKS }).map((_, i) => (
                <div
                  key={i}
                  className="w-1.5 h-1.5 rounded-full transition-all duration-300"
                  style={{
                    background: i < progressBlock ? currentAccent : 'rgba(255,255,255,0.15)',
                  }}
                />
              ))}
            </div>
          </motion.div>
        ) : null}

        <AnimatePresence mode="wait" custom={direction}>
          <motion.div
            key={step}
            custom={direction}
            variants={{
              enter: (d: number) => ({ opacity: 0, x: d > 0 ? 40 : -40 }),
              center: { opacity: 1, x: 0 },
              exit: (d: number) => ({ opacity: 0, x: d > 0 ? -40 : 40 }),
            }}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.45, ease: 'easeInOut' }}
          >
            {step === 0 ? (
              <section className="space-y-5">
                <div className="mb-8">
                  <p className="text-[10px] tracking-[0.4em] uppercase font-body mb-3" style={{ color: PAGE_ACCENT_SOFT }}>
                    Dados pessoais
                  </p>
                  <h2 className="font-display type-subtitle" style={{ color: 'var(--ink,#e8e0d5)' }}>
                    <em className="italic font-light">Quem é você?</em>
                  </h2>
                  <div
                    className="h-px w-16 mt-5"
                    style={{ background: `linear-gradient(90deg, ${PAGE_ACCENT_SOFT}55, transparent)` }}
                  />
                </div>
                <TextInput
                  id="field-email"
                  label="E-mail"
                  type="email"
                  value={email}
                  onChange={v => { setEmail(v); setError('') }}
                  accentSoft={PAGE_ACCENT_SOFT}
                />
                <TextInput
                  id="field-name"
                  label="Nome completo"
                  value={name}
                  onChange={v => { setName(v); setError('') }}
                  accentSoft={PAGE_ACCENT_SOFT}
                />
                <TextInput
                  id="field-whatsapp"
                  label="WhatsApp com DDD"
                  value={whatsapp}
                  onChange={v => { setWhatsapp(v); setError('') }}
                  accentSoft={PAGE_ACCENT_SOFT}
                />
                <TextInput
                  id="field-idade"
                  label="Idade"
                  value={idade}
                  onChange={v => { setIdade(v); setError('') }}
                  accentSoft={PAGE_ACCENT_SOFT}
                />
              </section>
            ) : null}

            {step >= 1 && step <= TOTAL_BLOCKS ? (() => {
              const block = BLOCKS[step - 1]
              return (
                <section>
                  <div className="mb-10 text-center sm:text-left">
                    <p
                      className="text-[10px] tracking-[0.4em] uppercase font-body mb-2 numerals"
                      style={{ color: block.accentSoft }}
                    >
                      {block.title}
                    </p>
                    <h2 className="font-display type-subtitle" style={{ color: 'var(--ink,#e8e0d5)' }}>
                      <em className="italic font-light">{block.subtitle}</em>
                    </h2>
                    <p className="font-body type-body mt-5" style={{ color: 'rgba(232,224,213,0.7)', lineHeight: 1.8 }}>
                      {block.intro}
                    </p>
                    <div
                      className="h-px w-16 mt-5 mx-auto sm:mx-0"
                      style={{ background: `linear-gradient(90deg, ${block.accentSoft}55, transparent)` }}
                    />
                  </div>
                  <div className="space-y-8">
                    {block.questions.map(q => (
                      <QuestionField
                        key={q.id}
                        id={q.id}
                        number={q.number}
                        label={q.label}
                        value={answers[q.id] || ''}
                        onChange={v => updateAnswer(q.id, v)}
                        accentSoft={block.accentSoft}
                      />
                    ))}
                  </div>
                </section>
              )
            })() : null}
          </motion.div>
        </AnimatePresence>

        <div className="mt-10 pt-4">
          {error ? (
            <motion.p
              initial={{ opacity: 0, y: -4 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-[13px] font-body text-center mb-4"
              style={{ color: '#f87171' }}
            >
              {error}
            </motion.p>
          ) : null}
          <button
            type="button"
            onClick={handleContinue}
            disabled={submitting}
            className="block w-full text-center btn-primary px-4 sm:px-8 py-5 min-h-[56px] rounded-sm type-button tracking-[0.12em] sm:tracking-[0.18em] uppercase disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {submitting
              ? 'Enviando...'
              : isLastStep
                ? 'Enviar minhas respostas'
                : 'Continuar'}
          </button>
          {isLastStep ? (
            <p className="text-[11px] font-body text-center mt-6 italic" style={{ color: 'rgba(232,224,213,0.45)' }}>
              Suas respostas são tratadas com total sigilo.
            </p>
          ) : null}
        </div>

        <footer className="mt-16 text-center">
          <div
            className="h-px w-24 mx-auto mb-6"
            style={{ background: `linear-gradient(90deg, transparent, ${PAGE_ACCENT_SOFT}44, transparent)` }}
          />
          <p className="text-[10px] tracking-[0.3em] uppercase font-body" style={{ color: 'rgba(232,224,213,0.45)' }}>
            Reacenda Luz · Mônica Maria
          </p>
        </footer>
      </div>
    </div>
  )
}

function TextInput({
  id, label, value, onChange, accentSoft, type = 'text',
}: {
  id: string
  label: string
  value: string
  onChange: (v: string) => void
  accentSoft: string
  type?: string
}) {
  return (
    <div id={id}>
      <label
        className="block text-[10px] tracking-[0.3em] uppercase font-body mb-2"
        style={{ color: accentSoft }}
      >
        {label}
      </label>
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        className="input-field w-full rounded-sm px-4 py-3 font-body text-[16px]"
        style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)',
          color: 'var(--ink,#e8e0d5)',
        }}
      />
    </div>
  )
}

function QuestionField({
  id, number, label, value, onChange, accentSoft,
}: {
  id: string
  number: number
  label: string
  value: string
  onChange: (v: string) => void
  accentSoft: string
}) {
  return (
    <div id={`field-${id}`}>
      <div className="flex items-baseline gap-3 mb-3">
        <span className="numerals text-[12px] tracking-[0.2em] font-body flex-shrink-0" style={{ color: accentSoft }}>
          {String(number).padStart(2, '0')}
        </span>
        <label
          htmlFor={id}
          className="font-body type-body"
          style={{ color: 'var(--ink,#e8e0d5)', lineHeight: 1.6 }}
        >
          {label}
        </label>
      </div>
      <textarea
        id={id}
        value={value}
        onChange={e => onChange(e.target.value)}
        rows={5}
        className="input-field w-full rounded-sm px-4 py-3 font-body text-[16px] resize-y"
        style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.1)',
          color: 'var(--ink,#e8e0d5)',
          lineHeight: 1.7,
          minHeight: 120,
        }}
        placeholder="Escreva sua resposta aqui..."
      />
    </div>
  )
}
